import React, { useEffect, useState } from "react";
import styles from "./AddDeliveryMethod.module.css";
import fetchData from "../../APIsControll/apiControll";
import { useAuth } from "../../components/context/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";

const defaultSubMethod = {
  subMethodName: "",
  unit: "",
  price: "",
  minAmount: "",
  maxWeight: "",
  maxVolume: "",
  maxLimit: 1,
  disclaimer: false,
  products: [],
  status: true,
  bookingLimit: true,
  addPartner: true,
};

const AddDeliveryMethod = () => {
  const { mode } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const type = location?.state?.type || "Add Delivery Method";

  const data = location?.state?.data || {};

  const productOptions = location?.state?.productOptions || [];

  const { show } = useToast();

  const [loading, setLoading] = useState({
    locationsLoading: false,
  });

  const [locations, setLocations] = useState({
    states: [],
    districts: [],
    subDistricts: [],
  });

  const [formData, setFormData] = useState({
    methodName: "",
    stateName: "",
    cityName: "",

    cityDelivery: true,
    stateDelivery: true,
    countryDelivery: true,
    customPartnerForm: true,
    methodSelection: true,
    status: true,

    subMethods: [defaultSubMethod],
  });

  // GET LOCATION
  useEffect(() => {
    getAllLocation();
  }, []);

  const getAllLocation = async () => {
    try {
      setLoading((prev) => ({
        ...prev,
        locationsLoading: true,
      }));

      const payload = {
        keyword: "",
        statename: data?.stateName || "",
        cityName: data?.cityName || "",
        courierId: data?._id || "",
      };

      const res = await fetchData(`locations/locations`, payload);

      // console.log("Location Response", res);

      if (res?.status === "success") {
        setLocations({
          states: res?.states || [],
          districts: res?.districts || [],
          subDistricts: res?.SubDistName || [],
        });

        setFormData((prev) => ({
          ...prev,
          stateName: data?.stateName || "",
          cityName: data?.cityName || "",
        }));
      }
    } catch (error) {
      show("Error fetching locations", "error");
    } finally {
      setLoading((prev) => ({
        ...prev,
        locationsLoading: false,
      }));
    }
  };

  // STATE CHANGE
  const handleStateChange = async (stateName) => {
    try {
      setFormData((prev) => ({
        ...prev,
        stateName,
        cityName: "",
      }));

      const payload = {
        keyword: "",
        statename: stateName,
        cityName: "",
        courierId: data?._id || "",
      };

      const res = await fetchData(`locations/locations`, payload);

      if (res?.status === "success") {
        setLocations((prev) => ({
          ...prev,
          districts: res?.districts || [],
          subDistricts: res?.SubDistName || [],
        }));
      }
    } catch (error) {
      show("Error fetching districts", "error");
    }
  };

  // INPUT CHANGE
  const handleSubMethodChange = (index, field, value) => {
    const updated = [...formData.subMethods];

    updated[index][field] = value;

    setFormData((prev) => ({
      ...prev,
      subMethods: updated,
    }));
  };

  // PRODUCT SELECT
  const handleProductSelect = (index, productId) => {
    const updated = [...formData.subMethods];

    const alreadyExist = updated[index]?.products?.includes(productId);

    if (alreadyExist) {
      updated[index].products = updated[index].products.filter(
        (item) => item !== productId,
      );
    } else {
      updated[index].products.push(productId);
    }

    setFormData((prev) => ({
      ...prev,
      subMethods: updated,
    }));
  };

  // ADD MORE
  const addMoreSubMethod = () => {
    setFormData((prev) => ({
      ...prev,
      subMethods: [...prev.subMethods, { ...defaultSubMethod }],
    }));
  };

  // DELETE
  const deleteSubMethod = (index) => {
    const updated = [...formData.subMethods];

    updated.splice(index, 1);

    setFormData((prev) => ({
      ...prev,
      subMethods: updated,
    }));
  };

  useEffect(() => {
    if (data._id) {
      const getDeliveryMethod = async () => {
        try {
          setLoading((prev) => ({
            ...prev,
            getDeliveryLoading: true,
          }));

          const payload = {
            statename: data?.stateName || "",
            cityName: data?.cityName || "",
            courierId: data?._id || "",
          };
          const res = await fetchData(
            `deliverymethod/getDeliveryMethod`,
            payload,
          );

          console.log("Delivery Method", res);

          if (res?.status === "success") {
            // setProductsOptions(res?.products || []);
          }
        } catch (error) {
          // show("Error fetching delivery methods", "error");
        } finally {
          setLoading((prev) => ({
            ...prev,
            getDeliveryLoading: false,
          }));
        }
      };
      getDeliveryMethod();
    }
  }, []);

  return (
    <div className={`${styles.method} ${mode ? styles.dark : styles.light}`}>
      {/* HEADER */}
      <div className={styles.method_top}>
        <TopTabBar text={type} />
      </div>

      {/* TOP FORM */}
      <div className={styles.topForm}>
        <div className={styles.inputGroup}>
          <label>Method Name</label>

          <input
            type="text"
            placeholder="Enter Method Name"
            value={formData.methodName}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                methodName: e.target.value,
              }))
            }
          />
        </div>

        {/* STATE */}
        <div className={styles.inputGroup}>
          <label>State Name</label>

          <select
            value={formData.stateName}
            onChange={(e) => handleStateChange(e.target.value)}
          >
            <option value="">Select State</option>

            {locations?.states?.map((state, index) => (
              <option key={index} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>

        {/* CITY */}
        <div className={styles.inputGroup}>
          <label>City Name</label>

          <select
            value={formData.cityName}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                cityName: e.target.value,
              }))
            }
          >
            <option value="">Select City</option>

            {locations?.districts?.map((city, index) => (
              <option key={index} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* SUB METHODS */}
      <div className={styles.subMethodWrapper}>
        <h3>Add Sub-Methods</h3>

        {formData?.subMethods?.map((item, index) => (
          <div className={styles.subMethodCard} key={index}>
            {/* HEADER */}
            <div className={styles.subHeader}>
              <span>Sub-Method {index + 1}</span>

              {formData?.subMethods?.length > 1 && (
                <button
                  className={styles.deleteBtn}
                  onClick={() => deleteSubMethod(index)}
                >
                  Delete
                </button>
              )}
            </div>

            {/* GRID */}
            <div className={styles.grid}>
              <div className={styles.inputGroup}>
                <label>Sub-Method Name</label>

                <input
                  type="text"
                  placeholder="Enter Sub-Method"
                  value={item.subMethodName}
                  onChange={(e) =>
                    handleSubMethodChange(
                      index,
                      "subMethodName",
                      e.target.value,
                    )
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Unit</label>

                <select
                  value={item.unit}
                  onChange={(e) =>
                    handleSubMethodChange(index, "unit", e.target.value)
                  }
                >
                  <option value="">Select Unit</option>

                  <option value="KG">KG</option>

                  <option value="CBM">CBM</option>

                  <option value="PIECE">PIECE</option>
                </select>
              </div>

              <div className={styles.inputGroup}>
                <label>Price</label>

                <input
                  type="number"
                  placeholder="Price"
                  value={item.price}
                  onChange={(e) =>
                    handleSubMethodChange(index, "price", e.target.value)
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Minimum Amount</label>

                <input
                  type="number"
                  placeholder="Minimum Amount"
                  value={item.minAmount}
                  onChange={(e) =>
                    handleSubMethodChange(index, "minAmount", e.target.value)
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Maximum Weight</label>

                <input
                  type="number"
                  placeholder="Maximum Weight"
                  value={item.maxWeight}
                  onChange={(e) =>
                    handleSubMethodChange(index, "maxWeight", e.target.value)
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Maximum Volume</label>

                <input
                  type="number"
                  placeholder="Maximum Volume"
                  value={item.maxVolume}
                  onChange={(e) =>
                    handleSubMethodChange(index, "maxVolume", e.target.value)
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Maximum Limit</label>

                <input
                  type="number"
                  value={item.maxLimit}
                  onChange={(e) =>
                    handleSubMethodChange(index, "maxLimit", e.target.value)
                  }
                />
              </div>
            </div>

            {/* PRODUCTS */}
            <div className={styles.productWrapper}>
              <label>Products</label>

              <div className={styles.productContainer}>
                {productOptions?.map((p, pIndex) => (
                  <button
                    type="button"
                    key={p?.product_id || pIndex}
                    className={`${styles.productTag} ${
                      item?.products?.includes(p?.product_id)
                        ? styles.activeTag
                        : ""
                    }`}
                    onClick={() => handleProductSelect(index, p?.product_id)}
                  >
                    + {p?.product_name}
                  </button>
                ))}
              </div>
            </div>

            {/* OPTIONS */}
            <div className={styles.bottomOptions}>
              {/* STATUS */}
              <div className={styles.radioGroup}>
                <label>Status</label>

                <div className={styles.radioRow}>
                  <label>
                    <input
                      type="radio"
                      checked={item.status === true}
                      onChange={() =>
                        handleSubMethodChange(index, "status", true)
                      }
                    />
                    Active
                  </label>

                  <label>
                    <input
                      type="radio"
                      checked={item.status === false}
                      onChange={() =>
                        handleSubMethodChange(index, "status", false)
                      }
                    />
                    Disable
                  </label>
                </div>
              </div>

              {/* BOOKING */}
              <div className={styles.radioGroup}>
                <label>Booking Limit</label>

                <div className={styles.radioRow}>
                  <label>
                    <input
                      type="radio"
                      checked={item.bookingLimit === true}
                      onChange={() =>
                        handleSubMethodChange(index, "bookingLimit", true)
                      }
                    />
                    Active
                  </label>

                  <label>
                    <input
                      type="radio"
                      checked={item.bookingLimit === false}
                      onChange={() =>
                        handleSubMethodChange(index, "bookingLimit", false)
                      }
                    />
                    Disable
                  </label>
                </div>
              </div>

              {/* PARTNER */}
              <div className={styles.radioGroup}>
                <label>Add Partner</label>

                <div className={styles.radioRow}>
                  <label>
                    <input
                      type="radio"
                      checked={item.addPartner === true}
                      onChange={() =>
                        handleSubMethodChange(index, "addPartner", true)
                      }
                    />
                    Active
                  </label>

                  <label>
                    <input
                      type="radio"
                      checked={item.addPartner === false}
                      onChange={() =>
                        handleSubMethodChange(index, "addPartner", false)
                      }
                    />
                    Disable
                  </label>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* ADD MORE */}
        <button className={styles.addMoreBtn} onClick={addMoreSubMethod}>
          + Add More Sub-Method
        </button>
      </div>

      {/* FOOTER OPTIONS */}
      <div className={styles.footerOptions}>
        {[
          "cityDelivery",
          "stateDelivery",
          "countryDelivery",
          "customPartnerForm",
          "methodSelection",
          "status",
        ].map((field, index) => (
          <div className={styles.radioGroup} key={index}>
            <label>
              {field
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())}
            </label>

            <div className={styles.radioRow}>
              <label>
                <input
                  type="radio"
                  checked={formData[field] === true}
                  onChange={() =>
                    setFormData((prev) => ({
                      ...prev,
                      [field]: true,
                    }))
                  }
                />
                Active
              </label>

              <label>
                <input
                  type="radio"
                  checked={formData[field] === false}
                  onChange={() =>
                    setFormData((prev) => ({
                      ...prev,
                      [field]: false,
                    }))
                  }
                />
                Disable
              </label>
            </div>
          </div>
        ))}
      </div>

      {/* BUTTONS */}
      <div className={styles.actionButtons}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          BACK
        </button>

        <button className={styles.createBtn}>CREATE</button>
      </div>
    </div>
  );
};

export default AddDeliveryMethod;
